import { FileRecordType } from "pages/SharedRecords.types";
import { createContext } from "react";

type FileDatagridContextType =
  | {
      setSelectedFile: (file: FileRecordType | null) => void;
      selectedFile: FileRecordType | null;
    }
  | undefined;

export const FileDatagridContext = createContext<FileDatagridContextType>(undefined);
